define(
    'providers/dataprovider.accounts',[
        "services/config"
    ],
    function(config) {

        function login(data) {
            var deferred = $.Deferred();
            amplify.request({
                resourceId: "login",
                data: data,
                success: function (result, statusCode) { deferred.resolve(result, statusCode);},
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }
        function logout(data) {
            var deferred = $.Deferred();
            amplify.request({
                resourceId: "logout",
                data: data,
                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }
        function validate() {
            var deferred = $.Deferred();
            amplify.request({
                resourceId: "validate",
                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }
        function resetPassword(callbacks, data) {
            var deferred = $.Deferred().resolve();
            return deferred.promise();
        }
        function getRole() {
            //0 - non user
            //1 - guest
            //2 - user
            //3 - administrator
            //4 - instance administrator
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-accounts-role",
                    data: {},
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getAttributes() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-accounts-attributes",
                    data: {},
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function sendResetPasswordLink(email, siteUrl) {
            var data = {
                username: email,
                siteUrl: siteUrl
            };
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-accounts-sendresetpasswordlink",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function validateResetPasswordLink(id) {
            var data = { id: id };
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-accounts-validateresetpasswordlink",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function updatePassword(id, password) {
            var data = { id: id, password: password };
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-accounts-validateresetpasswordlink",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function changePassword(personId, oldpassword, newpassword) {
            var data = { personId: personId, oldpassword: oldpassword, newpassword: newpassword };
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-accounts-change-password",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        init();

        return {
            login: login,
            logout: logout,
            validate: validate,
            resetPassword: resetPassword,
            getRole: getRole,
            getAttributes: getAttributes,
            sendResetPasswordLink: sendResetPasswordLink,
            validateResetPasswordLink: validateResetPasswordLink,
            updatePassword: updatePassword,
            changePassword: changePassword
        };

        //#region Internal Methods

        function init() {
            amplify.request.define("login", "ajax", {
                url: getUrl("login"),
                dataType: "json",
                type: "POST",
            });

            amplify.request.define("validate", "ajax", {
                url: getUrl("validate"),
                dataType: "json",
                decoder: "quiet", /* NOTE: prevents the global error handler firing, as this logic is dealth with by the guardRoute in main.js */
                type: "POST",
            });

            amplify.request.define("logout", "ajax", {
                url: getUrl("logout"),
                dataType: "json",
                decoder: "quiet", /* NOTE: prevents the global error handler firing */
                type: "POST",
            });

            amplify.request.define("reset-password", "ajax", {
                url: getUrl("resetPassword"),
                dataType: "json",
                contentType: "application/json",
                type: "POST"
            });

            amplify.request.define("get-accounts-role", "ajax", {
                url: getUrl("account/role"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-accounts-attributes", "ajax", {
                url: getUrl("account/attributes"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("put-accounts-sendresetpasswordlink", "ajax", {
                url: getUrl("account/password/sendresetlink/"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) { return JSON.stringify(data); }
            });

            amplify.request.define("get-accounts-validateresetpasswordlink", "ajax", {
                url: getUrl("account/password/resetlink/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("put-accounts-validateresetpasswordlink", "ajax", {
                url: getUrl("account/password/resetlink/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) { return JSON.stringify(data); }
            });

            amplify.request.define("put-accounts-change-password", "ajax", {
                url: getUrl("account/password/change/{personId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) { return JSON.stringify(data); }
            });
        }

        function getUrl(action) {
            return config.webApiUrl + action;
        }

        //#endregion
    }
);
